import React, { useCallback, useState } from 'react'
import { Alert } from 'components'
import { CheckBox } from 'components/Form'
import { PerformAlertStyles } from './Style'
import { alerts as alertKeys, gender } from 'keys'
import { useAlert } from 'components/Alerts/hooks'
import { useSelector } from 'react-redux'

const PerformAlert = () => {
    const { setAlerts } = useAlert()
    const { alerts } = useSelector(state => state.general)
    const [hidePerformAloneAlert, setHidePerformAloneAlert] = useState(false)

    const test_taker_name = alerts.performAssessment?.props?.test_taker
    const isMale = alerts.performAssessment?.props.gender === gender.male

    const setAlert = useCallback((val) => {
        setAlerts(alertKeys.performAssessment, val)
    }, [])

    const acceptMessage = useCallback(() => {
        alerts.performAssessment.props.onClose()
        setAlert(false)
        if (hidePerformAloneAlert) {
            localStorage.setItem("hidePerformAloneAlert", "true")
        } else {
            localStorage.removeItem("hidePerformAloneAlert")
        }
    }, [hidePerformAloneAlert])

    return (
        <Alert
            width={700}
            systemUI
            title={"תזכורת חשובה!"}
            footerActions={[{
                label: "הבנתי",
                color: "dark",
                className: "solid-round",
                action: acceptMessage
            }]}
            handleAlert={() => setAlert(false)}
        >
            <PerformAlertStyles>
                <div>
                    {`האבחון נועד לשקף את מה ש${test_taker_name} ${isMale ? "יודע" : "יודעת"}.`}
                </div>
                <div>
                    {"כל התערבות בקריאה, גם קטנה, עלולה לשבש את התמונה האמיתית."}
                </div>
                <div>
                    <b>
                        {`מוודאים ש${test_taker_name} ${isMale ? "הבין" : "הבינה"} את ההנחיות ונותנים ${isMale ? "לו" : "לה"} לקרוא לבד.`}
                    </b>
                </div>
                <div>
                    {"תודה על תשומת הלב ועל המקצועיות שלכן 💙."}
                </div>
                <CheckBox
                    input={{
                        value: hidePerformAloneAlert,
                        onChange: setHidePerformAloneAlert
                    }}
                    className="show-again-checkbox"
                    label="אל תציג שוב את ההודעה"
                />
            </PerformAlertStyles>
        </Alert>
    )
}

export default PerformAlert